const CMSFAccountsEmployees =  [
    "85a45485-782d-4318-8074-9c0bb331fdff", //shohaq kholifa
    "d0521cb1-4d20-425c-99ac-3173cae81bfe",// syed sadek hussain
    "27d69ebb-92b6-4c1b-8682-42eb744582be",// rayhan kawshaik
    "2629b816-9ae0-41a6-99bc-9e3caf02a1d7",//md. shamim hossain
    "b3afac75-247d-46e7-82b8-4a725e1620f7",//Habibullah Bahar khan
    "9b7f8234-d78a-42f7-98b6-21ef6e13db3f", //md. shahriar mahmud
];
  export default CMSFAccountsEmployees;